import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    archiveInquiry,
    deleteInquiry,
    getCurrentInquiry,
    resetArchiveInquiryStatus,
} from "../../store/reducers/InquiriesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface ArchiveInquiryScreenProps {
}

export const ArchiveInquiryScreen: React.FC<ArchiveInquiryScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const inquiriesState = useAppSelector((state) => state.inquiries);
    const requestStatus: RequestStatus = inquiriesState.archiveInquiryStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Päringud", url: "/inquiries"},
        {text: "Päringu arhiveerimine", url: `/inquiries/${id}/archive`},
    ];

    useEffect(() => {
        dispatch(resetArchiveInquiryStatus());
    }, [location]);

    const handleConfirm = () => {
        if (id) {
            dispatch(archiveInquiry(Number(id)));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (id) {
            dispatch(getCurrentInquiry({ id: parseInt(id) }));
        }
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    {inquiriesState?.currentInquiry?.archived_at &&
                    <h2>
                      Päring dearhiveeritud
                    </h2>
                    }
                    {!inquiriesState?.currentInquiry?.archived_at &&
                    <h2>
                      Päring arhiveeritud
                    </h2>
                    }
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    {inquiriesState?.currentInquiry?.archived_at &&
                    <h2>
                      Oled kindel, et soovid päringu dearhiveerida?
                    </h2>
                    }
                    {!inquiriesState?.currentInquiry?.archived_at &&
                    <h2>
                      Oled kindel, et soovid päringu arhiveerida?
                    </h2>
                    }
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};